import React from 'react';
import Image, {StaticImageData} from 'next/image';
import {Button} from '../shared/basics/Button';
import {Link} from '@website/navigation';
import {GoForwardIcon} from '../shared/icons/Pointers';

interface HealthServicesCardProps {
  icon: React.ReactNode;
  label: string;
  title: string;
  description: string;
  images: {
    src: StaticImageData;
    alt: string;
    width: number;
    height: number;
    className?: string;
  }[];
  buttonText: string;
  buttonHref?: string;
  cardClasses?: string;
}

const HealthServicesCard: React.FC<HealthServicesCardProps> = ({
  icon,
  label,
  title,
  description,
  images,
  buttonText,
  buttonHref = '#',
  cardClasses = 'bg-gray-100',
}) => {
  return (
    <section
      className={`flex flex-col ${cardClasses} rounded-3xl p-8 md:p-10 shadow-sm h-full`}
    >
      <div className="flex flex-col-reverse md:flex-row gap-10 h-full">
        <div className="flex-1 grid grid-cols-2 gap-4">
          {
            <>
              <div className="relative row-span-1 col-span-1 rounded-xl overflow-hidden">
                <Image
                  src={images[0].src}
                  alt={images[0].alt}
                  width={images[0].width}
                  height={images[0].height}
                  className={images[0].className}
                />
              </div>
              <div className="relative row-span-2 col-span-1 rounded-xl overflow-hidden">
                <Image
                  src={images[1].src}
                  alt={images[1].alt}
                  width={images[1].width}
                  height={images[1].height}
                  className={images[1].className}
                />
              </div>
              <div className="relative row-span-1 col-span-1 rounded-xl overflow-hidden">
                <Image
                  src={images[2].src}
                  alt={images[2].alt}
                  width={images[2].width}
                  height={images[2].height}
                  className={images[2].className}
                />
              </div>
              <div className="relative row-span-2 col-span-1 rounded-xl overflow-hidden">
                <Image
                  src={images[3].src}
                  alt={images[3].alt}
                  width={images[3].width}
                  height={images[3].height}
                  className={images[3].className}
                />
              </div>
              <div className="relative row-span-1 col-span-1 rounded-xl overflow-hidden -mt-16">
                <Image
                  src={images[4].src}
                  alt={images[4].alt}
                  width={images[4].width}
                  height={images[4].height}
                  className={images[4].className}
                />
              </div>
              <div className="relative row-span-1 col-span-1 rounded-xl overflow-hidden">
                <Image
                  src={images[5].src}
                  alt={images[5].alt}
                  width={images[5].width}
                  height={images[5].height}
                  className={images[5].className}
                />
              </div>
            </>
          }
        </div>

        <article className="flex flex-1 flex-col justify-between">
          <div className="mb-4 bg-white p-2 rounded-xl w-fit">{icon}</div>
          <p className="text-sm mb-1">{label}</p>
          <h3 className="text-3xl font-montserrat font-bold mb-4">{title}</h3>
          <p className="leading-relaxed mb-4">{description}</p>
          <div className="mt-auto pt-2">
            <Button btnType="black" className="px-4 py-2 !rounded-full">
              <Link href={buttonHref} className="flex items-center gap-2">
                <GoForwardIcon
                  fillColor="currentColor"
                  strokeColor="currentColor"
                  strokeWidth={0.2}
                  height={13}
                  width={14.5}
                />
                <span>{buttonText}</span>
              </Link>
            </Button>
          </div>
        </article>
      </div>
    </section>
  );
};

export default HealthServicesCard;
